module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/envelope-ed6b384e152f09dd1712a04c701b47ac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/envelope.svg
// module id = KN4X
// module chunks = 24